import getCookie from '@/lib/get-cookie';
import { AxiosRequestConfig } from "axios";

export default function getBearerAuth(): AxiosRequestConfig {
    const token = getCookie('user_token', false);

    return {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        maxContentLength: Infinity,
        maxBodyLength: Infinity
    };
}
